export default {
      id: "type_contrat-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#type_contrat-usage",
      toString: function () {
        return this.url;
      }
    }